import { EChatWindowActionTypes } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { IActiveReplyMessage } from '../../types/messageReply';

/**
 * Открыть чат
 */
export const openChat = actionGenerator<EChatWindowActionTypes.OpenChat, string>(EChatWindowActionTypes.OpenChat);
export const closeChat = actionGenerator<EChatWindowActionTypes.CloseChat>(EChatWindowActionTypes.CloseChat);
export const resetChat = actionGenerator<EChatWindowActionTypes.ResetChat>(EChatWindowActionTypes.ResetChat);
export const increaseCountClosedChats = actionGenerator<EChatWindowActionTypes.IncreaseCountClosedChats>(
  EChatWindowActionTypes.IncreaseCountClosedChats,
);
export const setActiveReplyMessage = actionGenerator<EChatWindowActionTypes.SetActiveReplyMessage, IActiveReplyMessage>(
  EChatWindowActionTypes.SetActiveReplyMessage,
);
export const clearActiveReplyMessage = actionGenerator<EChatWindowActionTypes.ClearActiveReplyMessage>(
  EChatWindowActionTypes.ClearActiveReplyMessage,
);
